import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApplicationHttpService } from "../../../core/services/application-http.service";

/** Document download / generation / upload / replacement for an application. */
@Injectable()
export class ApplicationDocumentService {

    constructor(private http: ApplicationHttpService) {
    }

    getDocument(id: number): Observable<Blob> {
        return this.http.getFile(`document/download/${id}`);
    }

    generateAssessment(applicationId: number, id: number): Observable<Blob> {
        return this.http.getFile(`report/generate/assessment/${id}`);
    }

    uploadFile(applicationId: number, file: File): Observable<any> {
        const formData = new FormData();
        formData.append('code', 'USER_DOCUMENT');
        formData.append('file', file);

        return this.http.uploadFile(`back-office-document/${applicationId}/upload`, formData);
    }

    uploadRequestUpdateFile(applicationId: number, file: File): Observable<any> {
        const formData = new FormData();
        formData.append('code', 'RETURN_DOCUMENT');
        formData.append('file', file);

        return this.http.uploadFile(`back-office-document/${applicationId}/upload`, formData);
    }

    replaceFile(applicationId: number, file: File, documentId: number): Observable<any> {
        const formData = new FormData();
        formData.append('documentId', documentId.toString());
        formData.append('file', file);

        return this.http.uploadFile(`back-office-document/${applicationId}/replace`, formData);
    }
}
